import {useApolloClient} from '@apollo/client';
import {useCallback, useEffect, useRef} from 'react';
import {Toaster, toast} from 'sonner';
import {DeactivationProgressToast} from './DeactivationProgressToast';
import {
  useBulkDeactivationRun,
  useConfigureBulkDeactivation,
} from './useBulkDeactivation';

const TOAST_ID = 'members-bulk-deactivation';

export const DeactivationToaster = () => {
  const client = useApolloClient();
  const shownJobId = useRef<string | null>(null);
  const handleComplete = useCallback(() => {
    client.refetchQueries({include: ['ClientStaffMembers']});
  }, [client]);

  useConfigureBulkDeactivation(client, handleComplete);

  const run = useBulkDeactivationRun();

  useEffect(() => {
    if (run && shownJobId.current !== run.jobId) {
      shownJobId.current = run.jobId;
      toast.custom(id => <DeactivationProgressToast toastId={id} />, {
        id: TOAST_ID,
        duration: Infinity,
      });
    }
    if (!run && shownJobId.current !== null) {
      shownJobId.current = null;
      toast.dismiss(TOAST_ID);
    }
  }, [run]);

  return <Toaster position="bottom-right" />;
};
